var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { Buttons, Tabs } from "../../index";
import { CopyThin, NewWindowThin, tokens as tokensList } from "../..";
import { Box, MainBox, Text } from "./Common";
import { FarmingPoolTab, LiquidityPoolTab, TokensTab } from "./Tabs";
var FlareButton = Buttons.FlareButton;
var buttonTheme = {
    fontFamily: "'Poppins', sans-serif",
    button: {
        padding: {
            small: "8px 15.5px",
        },
        minHeight: {
            small: "32px",
        },
        primary: {
            color: "#E2665C",
            background: "rgba(226, 102, 92, 0.2)",
            border: "0",
            borderRadius: "0",
            hoverColor: "#E2665C",
            hoverBackground: "rgba(226, 102, 92, 0.4)",
            hoverBorderColor: "rgba(226, 102, 92, 0.4)",
        },
    },
};
var tabTheme = {
    tabs: {
        justifyContent: "space-evenly",
    },
};
export function MenuLoggedIn(_a) {
    var _this = this;
    var address = _a.address, balance = _a.balance, tokens = _a.tokens, tabs = _a.tabs, hidePriceAndPl = _a.hidePriceAndPl;
    var _b = useState(0), activeTab = _b[0], setActiveTab = _b[1];
    var _c = useState([]), tokenInput = _c[0], setTokenInput = _c[1];
    useEffect(function () {
        var tokensGathered = [];
        var getRandomInt = function (max, negative) {
            if (negative === void 0) { negative = false; }
            var num = Math.floor(Math.random() * max).toFixed(2);
            return parseInt(num) % 2 && negative ? "-" + num : num;
        };
        tokens.forEach(function (t) {
            var tkn = tokensList.find(function (token) { return token.name === t.name; });
            if (!tkn)
                return;
            var tIcon = tkn.icon && React.createElement(tkn.icon, { width: 35 });
            var tName = tkn.name;
            var tBalance = t.balance;
            var tPl = parseFloat(getRandomInt(500, true));
            var tVal = "$" + getRandomInt(2000);
            tokensGathered.push({
                tokenIcon: tIcon,
                tokenName: tName,
                tokenVal: tVal,
                balance: tBalance,
                pl: tPl,
            });
        });
        setTokenInput(tokensGathered);
    }, [tokens]);
    return (React.createElement(MainBox, null,
        React.createElement(Box, { padding: "24px 0 0" },
            React.createElement("div", { style: { width: "38%" } },
                React.createElement(FlareButton, { size: "small", theme: buttonTheme, buttonType: "primary", icon: React.createElement(CopyThin, null), position: "right", onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        var err_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!navigator.clipboard) {
                                        return [2 /*return*/];
                                    }
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, navigator.clipboard.writeText(address)];
                                case 2:
                                    _a.sent();
                                    return [3 /*break*/, 4];
                                case 3:
                                    err_1 = _a.sent();
                                    console.error("Failed to copy!", err_1);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); } }, "Copy address")),
            React.createElement("div", { style: { width: "38%" } },
                React.createElement(FlareButton, { size: "small", buttonType: "primary", icon: React.createElement(NewWindowThin, null), position: "right", onClick: function () {
                        return window.open("https://songbird-explorer.flare.network/address/" + address);
                    } }, "Explore"))),
        React.createElement(Box, { direction: "column", padding: "48px 0 57px", alignItems: "center" },
            React.createElement(Text, { color: "#838383" }, "Total Balance"),
            React.createElement(Text, { fontSize: "40px", lineHeight: "60px" }, balance)),
        React.createElement(Box, null,
            React.createElement(Tabs, { theme: tabTheme, activeTab: activeTab, onTabChange: function (i) { return setActiveTab(i); }, tabs: tabs || ["Tokens", "Liquidity pools", "Farming  pools"] })),
        React.createElement("div", { style: { maxHeight: "35vh", overflowY: "auto" } },
            activeTab === 0 && (React.createElement(TokensTab, { input: tokenInput, hidePriceAndPl: hidePriceAndPl })),
            activeTab === 1 && React.createElement(LiquidityPoolTab, null),
            activeTab === 2 && React.createElement(FarmingPoolTab, null))));
}
